export const DefaultColWidth = 150;
